import { differenceInYears, parseISO, startOfToday } from "date-fns";
import profileImageWebp from "../../assets/images/profile.webp";
import profileImagePng from "../../assets/images/profile.png";

function Hero() {
  const birthDate = parseISO("1984-07-04");
  const today = startOfToday();
  const age = differenceInYears(today, birthDate);

  return (
    <section
      id="hero"
      className="bg-blue-50 px-6 pt-12 md:px-12 md:pt-16 xl:px-24"
    >
      <div className="fade-in-section mx-auto max-w-7xl py-12 md:py-20">
        <div className="rounded-3xl bg-white p-6 sm:p-10 lg:p-16">
          <div className="grid items-center gap-8 md:gap-12 lg:grid-cols-2 lg:gap-16">
            <div className="order-2 lg:order-1">
              <div className="mb-6">
                <div className="mb-4">
                  <div className="mb-4 flex flex-wrap items-center gap-2">
                    <span className="inline-block rounded-full bg-blue-100 px-4 py-1.5 text-sm text-blue-700">
                      Owner
                    </span>
                    <span className="inline-block rounded-full bg-blue-100 px-4 py-1.5 text-sm text-blue-700">
                      Senior Engineer
                    </span>
                  </div>
                  <div className="flex flex-col items-start gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4">
                    <div className="flex flex-col leading-tight">
                      <p className="text-base text-gray-500">Nakamura Daichi</p>
                      <h1 className="text-xl text-gray-900">中村 大地</h1>
                    </div>
                    <div className="flex items-center gap-2 rounded-xl bg-slate-100 px-3 py-2 text-sm text-gray-800">
                      <i className="ri-map-pin-2-line text-base text-gray-600"></i>
                      所在地： 岡山県
                    </div>
                    <div className="flex items-center gap-2 rounded-xl bg-slate-100 px-3 py-2 text-sm text-gray-800">
                      <i className="ri-calendar-line text-base text-gray-600"></i>
                      {age}歳（{birthDate.getFullYear()}年生まれ）
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-6">
                <div className="flex items-start gap-3 text-gray-700">
                  <p className="leading-relaxed">
                    15年以上のソフトウェア開発経験を軸に、フルスタック開発からクラウドアーキテクチャまで幅広い領域で価値を提供しています。スケーラブルなシステム設計と、チームを牽引する技術リーダーシップが強みです。
                  </p>
                </div>

                <div className="flex items-start gap-3 text-gray-700">
                  <p className="leading-relaxed">
                    さらに、
                    <span className="font-bold">
                      ChatGPT・Gemini・Cursor・Claude・Devin・Figma Make・Readdy
                      AI・Genspark AI
                    </span>{" "}
                    などのAIを活用したバイブコーディングにより、
                    <span className="font-bold">「経験 × AI」</span>
                    で開発スピードと品質を両立し、高い完成度のアプリケーションを迅速に開発します。
                  </p>
                </div>
              </div>
            </div>

            <div className="order-1 flex justify-center lg:order-2 lg:justify-end">
              <div className="h-72 w-72 overflow-hidden rounded-full shadow-2xl ring-8 ring-blue-100 sm:h-80 sm:w-80 lg:h-96 lg:w-96">
                <picture>
                  <source srcSet={profileImageWebp} type="image/webp" />
                  <img
                    src={profileImagePng}
                    alt="中村 大地"
                    width={960}
                    height={960}
                    loading="eager"
                    fetchPriority="high"
                    decoding="async"
                    className="h-full w-full object-cover"
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
